import LoginPage from '../views/Login';
import PolicyPage from '../views/Policy';

const publicRoutes = [
  {
    path: '/login',
    component: LoginPage,
  },
  {
    path: '/policy',
    component: PolicyPage,
  },
  {
    path: '/',
    redirect: true,
    pathTo: '/login',
  },
];

export default publicRoutes;
